var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.141,
    height: 55.645,
    viewBox: "0 0 61.141 55.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-6.89 -6.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1372208999936",
    transform: "translate(7.46 6.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M67.46,33.872l-7.5,13.661-7.5,13.661h-30l-7.5-13.661L7.46,33.872l7.5-13.661L22.46,6.55h30l7.5,13.661Z",
    transform: "translate(-7.46 -6.549)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M506.321,20.2h-15L483.82,6.54",
    transform: "translate(-453.82 -6.54)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M483.82,670.971l7.5-13.661h15",
    transform: "translate(-453.82 -616.326)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M498.82,61.194l-7.5-13.661-7.5-13.661,7.5-13.661,7.5-13.661",
    transform: "translate(-453.82 -6.549)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M729.5,250.783,722,237.122l7.5-13.662",
    transform: "translate(-677 -209.799)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M126.55,20.2h15l7.5-13.661",
    transform: "translate(-119.05 -6.54)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M149.06,670.971l-7.5-13.661h-15",
    transform: "translate(-119.059 -616.326)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M245.64,61.194l7.5-13.661,7.5-13.661-7.5-13.661L245.64,6.55",
    transform: "translate(-230.64 -6.549)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M126.56,250.783l7.5-13.661-7.5-13.662",
    transform: "translate(-119.059 -209.799)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 29.999,
    y2: 0.001,
    transform: "translate(15.001 27.322)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiShape);
export default __webpack_public_path__ + "static/media/origami-shape.3528415428b965e8b0912107dd676fd2.svg";
export { ForwardRef as ReactComponent };